import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { WineryInfoService } from '../winery-info.service';
import { TranslateService } from '@ngx-translate/core';
import { locales } from '@util/locale';
import { PreorderLinkService } from '../link.service';

@Injectable({
  providedIn: 'root',
})
export class LinkResolver implements Resolve<any> {
  constructor(
    private wineryInfo: WineryInfoService,
    private translate: TranslateService,
    private preorderLinkService: PreorderLinkService,
    private router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const paramLinkId = route.paramMap.get('id');
    const storedServiceLinkId = this.preorderLinkService.linkId;

    // Fallback da sessionStorage (utile se stai su /cart o /preorder)
    const sessionMeta = sessionStorage.getItem('wineryMeta');
    const sessionLinkId = sessionMeta ? JSON.parse(sessionMeta).linkId : null;

    const linkId = paramLinkId || storedServiceLinkId || sessionLinkId;

    if (!linkId) {
      const { wineryId, channelId } = route.queryParams || {};

      // If linkId is not available, check if wineryId and channelId are provided
      if (wineryId && channelId) {
        // Load directly with winery and channel info
        this.wineryInfo.load(wineryId, channelId);
        return of(null); // Return an empty observable to indicate no further processing
      }

      return of(null);
    }

    this.preorderLinkService.linkId = linkId;

    return this.preorderLinkService.get(linkId).pipe(
      concatMap(link => {
        if (link === null) {
          this.wineryInfo = null;
          sessionStorage.clear();
          return of(null);
        }

        this.wineryInfo.loadOptions(link.id);
        this.wineryInfo.load(link.wineryId, link.wineryChannelId);

        const storedLang = localStorage.getItem('locale');
        const fallbackLang = link.options?.language || 'it';
        const langToUse = storedLang || fallbackLang;

        this.translate.setDefaultLang(langToUse);
        this.translate.use(langToUse);

        // Sincronizza con sistema locale
        // Salva temporaneamente la lingua corrente per locale()
        (window as any).__currentLang = langToUse;

        return of(link);
      }),
      catchError(err => {
        console.error('[LinkResolver] Errore:', err);
        return of(null);
      }),
    );
  }
}
